interface RadioButtonProps {
  children?: React.ReactNode;
  label: string;
  sublabel1?: string;
  sublabel2?: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  icon: string;
}

const RadioButton = ({
  children,
  label,
  sublabel1,
  sublabel2,
  value,
  checked,
  onChange,
  icon,
}: RadioButtonProps) => {
  return (
    <div
      className={`flex items-center gap-3.5 p-3.5 rounded-[6px] w-full h-full min-h-[72px] cursor-pointer transition-all duration-150 ${
        checked
          ? "border-[1.5px] border-[#28543D] bg-[#EEF0E3] shadow-[0_0_0_3px_rgba(40,84,61,0.10)]"
          : "border-[1.5px] border-[#d9d7ca] bg-[#fdfbf6] hover:border-[#c8cebd]"
      }`}
      onClick={() => onChange(value)}
    >
      <span
        className={`flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full transition-colors duration-150 ${
          checked
            ? "border-2 border-[#28543D]"
            : "border-[1.5px] border-[#c8cebd]"
        }`}
      >
        {checked && (
          <span className="h-[11px] w-[11px] rounded-full bg-[#28543D]" />
        )}
      </span>
      <div className="flex flex-col justify-center min-w-0 flex-1">
        <span className="text-[15px] font-bold text-[#28513e] leading-tight">
          {label}
        </span>
        {sublabel1 && (
          <span className="text-[13px] text-[#687368] font-medium mt-0.5">
            {sublabel1}
          </span>
        )}
        {sublabel2 && (
          <span className="text-[13px] text-[#687368] font-normal mt-0.5">
            {sublabel2}
          </span>
        )}
        {children}
      </div>
      {icon && (
        <img
          src={icon}
          alt={label}
          className="h-[18px] w-[26px] rounded-[3px] object-cover shadow-[0_0_0_1px_rgba(0,0,0,0.06)] flex-shrink-0"
        />
      )}
    </div>
  );
};

export default RadioButton;
